export default class Club {
  constructor(data) {
    Object.assign(this, data)
  }

  static fromArray(data) {
    return data.map(item => new Club(item))
  }
}